/**
 * DES-14 : une seule place pour les bandeaux, un seul bandeau à la fois.
 * Priorité : imitation de compte > téléphonie > session en pause > statut CRM.
 * Chaque bandeau futur (imitation W7, pause W3, CRM W4) s'ajoute ici au lieu
 * de s'empiler en haut de page.
 */
export const BANNER_PRIORITY = ['impersonation', 'telephony', 'sessionPaused', 'crmStatus'] as const;
export type BannerKind = (typeof BANNER_PRIORITY)[number];

export function pickBanner(active: Partial<Record<BannerKind, boolean>>): BannerKind | null {
  return BANNER_PRIORITY.find((kind) => active[kind]) ?? null;
}
